// @import_dependencies
import { store } from 'app_storage/redux-storage'
import moment from 'moment'
// @end

// @import services
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import utilities
import { IFetchSatisfactionSummary, IFetchClassesTaught, IFetchCoursesTaught } from 'app_types/campus/academic/statsTypes'
// @end

// @import types
// @end

class StatsService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor() {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  fetchSatisfactionSummary = async (params: any) => {
    this.refreshAuthToken()
    let user = this.storeObject?.getState().auth?.user?.data;
    params.teacher = user.id;

    let responseData: IFetchSatisfactionSummary

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/stats/surveys`,
      auth_token: this.token,
      params,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }
    return false
  }

  /*
  Reporte de horas programadas para el docente, requiere Id de docente.
  */
  fetchClassesTaught = async (params: any) => {
    this.refreshAuthToken()

    let user = this.storeObject?.getState().auth?.user?.data;
    params.teacher = user.id;

    let responseData: IFetchClassesTaught

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/stats/hours`,
      auth_token: this.token,
      params,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }
    return false
  }

  fetchCoursesTaught = async (params: any) => {
    this.refreshAuthToken()
    let user = this.storeObject?.getState().auth?.user?.data;
    params.teacher = user.id;

    let responseData: IFetchCoursesTaught

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/stats/courses`,
      auth_token: this.token,
      params,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }
    return false
  }


  private customData = (startDate: moment.Moment, ticks: number) => {
    let labels = []
    let data = []
    for (let index = 0; index < ticks; index++) {
      labels.push(startDate.format('YYYY-MM-DD'))
      data.push(Math.floor(Math.random() * (24 - 1)) + 1)

      startDate.add('1', 'day')
    }

    return {
      labels, data
    }
  }
}

export default StatsService
